import type { ChannelGenre, ChannelSummary } from '@apm/contracts';
import type { MessageKey } from './i18n/ko.js';

/**
 * 채널 이름 밑의 배지 (v33-g · 2026-09-23). **편성표 · 홈 카드 · 홈 상단이 이것 하나를 부른다.**
 *
 * - 홈쇼핑 — 종류가 곧 배지다(「홈쇼핑」)
 * - 일반 — **장르**(`ChannelSummary.genre`)다. **없으면 배지가 없다**(`null`)
 *
 * 전에는 세 자리가 각자 `kind === 'general'` 을 곧 「드라마」로 그렸다 — 스포츠 채널이 생기자
 * 셋 다 거짓이 됐다(무대 신고). **모르는 장르를 지어내지 않는다.**
 *
 * **키를 문자열로 조립하지 않는다**(`channels.genre.${genre}`) — 표로 두어야 장르가 늘 때
 * 빠진 키를 `typecheck` 가 잡는다(`Record<ChannelGenre, …>`).
 */
const GENRE_KEYS: Record<ChannelGenre, MessageKey> = {
  drama: 'channels.genre.drama',
  movie: 'channels.genre.movie',
  sports: 'channels.genre.sports',
  news: 'channels.genre.news',
  entertainment: 'channels.genre.entertainment',
  documentary: 'channels.genre.documentary',
};

export function channelBadgeKey(
  channel: Pick<ChannelSummary, 'kind' | 'genre'>,
): MessageKey | null {
  if (channel.kind === 'homeshopping') return 'channels.kindHomeshopping';
  return channel.genre === null ? null : GENRE_KEYS[channel.genre];
}
